<template>
  <div id="edit-vorlage-view">
    <div v-if="!loading && vorlageid != '0' && vorlage == null" class="alert alert-danger">
      Es wurde keine Vorlage gefunden

      <button type="button" class="btn btn-secondary me-3" @click="cancel()">Zurück</button>
    </div>

    <div v-else @dragover.prevent @drop="dropToAvailable">
      <form id="edit-vorlage-form" @submit.prevent="saveVorlage">
        <div id="edit-vorlage-form-main">
          <div class="d-flex justify-content-between mb-3">
            <h1 v-if="editVorlage.id == 0" class="mb-0">Neue Vorlage</h1>
            <h1 v-else class="mb-0">Vorlage {{ vorlage?.name }} bearbeiten</h1>
          </div>

          <div class="d-flex">
            <div class="form-check me-3">
              <input class="form-check-input" type="radio" name="vorlageNeuvertrag" id="vorlageNeuvertrag" :value="0" v-model="editVorlage.type" />
              <label class="form-check-label" for="vorlageNeuvertrag">Neuvertrag</label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="radio" name="vorlageNachtrag" id="vorlageNachtrag" :value="1" v-model="editVorlage.type" />
              <label class="form-check-label" for="vorlageNachtrag">Nachtrag</label>
            </div>
          </div>

          <!-- <pre>{{ vorlage }}</pre> -->

          <hr class="my-4" />

          <div v-if="!loading && errorMsg != ''" class="alert alert-danger my-4">
            {{ errorMsg }}
          </div>

          <div v-if="!loading && ownErrorMsg != ''" class="alert alert-danger my-4">
            <div :innerHTML="ownErrorMsg"></div>
          </div>

          <div class="row">
            <div class="col-5">
              <div class="mb-3">
                <label for="vorlageTitel" class="form-label fw-bold">Vorlage Bezeichnung</label>
                <input type="text" class="form-control" id="vorlageTitel" placeholder="Arbeitsvertrag 1" v-model="editVorlage.name" />
              </div>

              <div>
                <label for="vorlageDocId" class="form-label fw-bold">Dokument ID</label>
                <input type="text" class="form-control" id="vorlageDocId" maxlength="20" v-model="editVorlage.docId" />
              </div>
            </div>

            <div class="col-5 offset-1">
              <div class="mb-3">
                <label for="vorlageGruppe" class="form-label fw-bold">Gruppe</label>
                <input type="text" class="form-control" id="vorlageGruppe" v-model="editVorlage.gruppe" />
              </div>

              <div>
                <label for="vorlageActionId" class="form-label fw-bold">Action ID</label>
                <input type="text" class="form-control" id="vorlageActionId" maxlength="20" v-model="editVorlage.actionId" />
              </div>
            </div>
          </div>

          <hr class="my-4" />

          <div class="row">
            <div class="col-4 offset-2">
              <label for="vorlageTitel" class="form-label fw-bold">Vertrag Titel</label>
              <input type="text" class="form-control" id="vorlageTitel" placeholder="Arbeitsvertrag" v-model="editVorlage.titel" />
            </div>

            <div class="col-4">
              <label for="vorlageTitelEN" class="form-label fw-bold">Vertrag Titel EN</label>
              <input type="text" class="form-control" id="vorlageTitelEN" placeholder="Contract" v-model="editVorlage.titelEN" />
            </div>
          </div>

          <div class="container">
            <h3>Abschnitte</h3>

            <div class="input-group input-group-sm my-auto mb-3">
              <input v-model.trim="selectedSearchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." />
              <span class="input-group-text">
                <font-awesome-icon icon="magnifying-glass" class="p-1" />
              </span>
            </div>

            <div id="selected-bausteine" class="dropzone pb-5" @dragover.prevent @drop="dropToSelected">
              <div
                v-for="(vorlageTextbaustein, index) in selectedTextbausteine
                  .sort((a, b) => a.position - b.position)
                  .filter(
                    (a) =>
                      a.textbaustein.titel.trim().toLowerCase().includes(selectedSearchString.trim().toLowerCase()) ||
                      a.textbaustein.name.trim().toLowerCase().includes(selectedSearchString.trim().toLowerCase())
                  )"
                :key="index"
                class="mb-2"
                draggable="true"
                @dragstart="startDrag(vorlageTextbaustein)"
                @dragover="handleDragOver"
                @dragenter="handleDragEnter(vorlageTextbaustein)"
                @dragleave="handleDragLeave($event, vorlageTextbaustein)"
                @drop="handleDrop($event, vorlageTextbaustein)"
                :class="{ 'drop-target': dropTargetId === vorlageTextbaustein.textbausteinid }"
              >
                <VorlageTextbausteinRow :textbaustein="vorlageTextbaustein" :vorlage="editVorlage" :index="index" />
              </div>
            </div>
          </div>

          <div v-if="errorMsg != ''" class="alert alert-danger my-4">
            {{ errorMsg }}
          </div>

          <div v-if="ownErrorMsg != ''" class="alert alert-danger my-4">
            <div :innerHTML="ownErrorMsg"></div>
          </div>

          <div v-if="editVorlage.id != 0">
            <hr class="my-4" />
            <button type="button" class="btn btn-danger" @click="deleteVorlageRequest()"><font-awesome-icon icon="trash" /> Vorlage löschen</button>
          </div>
        </div>

        <aside class="edit-vorlage-sidebar sidebar-fixed">
          <div id="edit-vorlage-sidebar-navbar-platzhalter" class="bg-sidebar border-start border-bottom"></div>

          <div class="bg-sidebar border-start border-top border-bottom shadow-sm px-1 py-2">
            <p><strong>Textbausteine</strong></p>

            <div class="input-group input-group-sm my-auto mb-3">
              <input v-model.trim="notSelectedSearchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." />
              <span class="input-group-text">
                <font-awesome-icon icon="magnifying-glass" class="p-1" />
              </span>
            </div>

            <div id="available-bausteine" class="dropzone">
              <div v-for="(value, key) in notSelectedGroupedItems" :key="key" class="mb-4">
                <p>
                  <strong>{{ key }}</strong>
                </p>

                <div
                  v-for="textbaustein in value"
                  :key="textbaustein.id"
                  class="mb-2 bg-white shadow-sm p-2 selectable-textbaustein"
                  draggable="true"
                  @dragstart="notSelectedStartDrag(textbaustein)"
                >
                  <strong>{{ textbaustein.name }}</strong> ({{ textbaustein.titel }})
                </div>
              </div>
            </div>
          </div>
        </aside>

        <div class="save-bar bg-white position-fixed bottom-0 end-0 p-3 w-100 shadow border-top d-flex justify-content-end">
          <button type="button" class="btn btn-secondary me-3" @click="cancel()">Abbrechen</button>
          <button type="submit" class="btn btn-primary me-3">Speichern</button>
        </div>
      </form>
    </div>
  </div>

  <ConfirmationAlert ref="confirmationAlertRef" @confirm="deleteVorlage" />

  <!-- <pre>{{ editVorlage }}</pre> -->
  <LoadingOverlay v-if="loading || getTextbausteineLoading" text="... Daten werden geladen ..." />
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, ref, PropType, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';

  import { ActionTypes as VorlageActionTypes } from '@/store/modules/Vorlagen/actions';
  import { ActionTypes as VariablenActionTypes } from '@/store/modules/Variablen/actions';

  import ConfirmationAlert from '@/components/ConfirmationAlert.vue';
  import VorlageTextbausteinRow from '@/components/Vorlagen/VorlageTextbausteinRow.vue';
  import LoadingOverlay from '@/components/LoadingOverlay.vue';

  import { Textbaustein, Vorlage, VorlageTextbaustein, GroupedTextbausteine, VorlageAbschnittRegel } from '@/models/VorlageModels';
  //#endregion

  //#region Init
  const props = defineProps({
    vorlageid: {
      type: String as PropType<string>,
      default: '0',
    },
  });

  const store = useStore();
  const router = useRouter();
  //#endregion

  const notSelectedSearchString = ref('');
  const notSelectedTextbausteine = computed(() =>
    textbausteine.value
      .filter((textbaustein: Textbaustein) => !selectedTextbausteine.value.map((t) => t.textbausteinid).includes(textbaustein.id))
      .filter(
        (textbaustein: Textbaustein) =>
          textbaustein.name.trim().toLowerCase().includes(notSelectedSearchString.value.trim().toLowerCase()) ||
          textbaustein.titel.trim().toLowerCase().includes(notSelectedSearchString.value.trim().toLowerCase()) ||
          textbaustein.gruppe.trim().toLowerCase().includes(notSelectedSearchString.value.trim().toLowerCase())
      )
      .sort((a: Textbaustein, b: Textbaustein) => {
        var groupComparison = a.gruppe.trim().toLowerCase().localeCompare(b.gruppe.trim().toLowerCase());

        if (groupComparison == 0) {
          var nameComparison = a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase());
          return nameComparison;
        }

        return groupComparison;
      })
  );

  const notSelectedGroupedItems = computed<GroupedTextbausteine>(() => {
    const noGroup: Textbaustein[] = [];

    const data = notSelectedTextbausteine.value.reduce((groups: GroupedTextbausteine, textbaustein: Textbaustein) => {
      if (!textbaustein.gruppe) {
        noGroup.push(textbaustein);
      } else {
        const groupsList = textbaustein.gruppe.split(';');

        for (let group of groupsList) {
          group = group.trim();

          if (group === '') {
            continue;
          }

          const existingGroup = groups[group];

          if (existingGroup) {
            existingGroup.push(textbaustein);
          } else {
            groups[group] = [textbaustein];
          }
        }
      }
      return groups;
    }, {});

    // Sort keys alphabetically
    const sortedData: GroupedTextbausteine = {};
    Object.keys(data)
      .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
      .forEach((key) => {
        sortedData[key] = data[key];
      });

    if (noGroup.length > 0) {
      sortedData['Keine Gruppe'] = noGroup;
    }

    return sortedData;
  });

  const selectedSearchString = ref('');
  const selectedTextbausteine = ref(new Array<VorlageTextbaustein>());

  function reorderSelected() {
    for (let [index, selected] of selectedTextbausteine.value.sort((a, b) => a.position - b.position).entries()) {
      selected.position = index + 1;
    }
  }

  //#region Drag & Drop
  const notSelectedDraggedItem = ref<Textbaustein | null>(null);

  // Drag starten
  function notSelectedStartDrag(baustein: Textbaustein) {
    notSelectedDraggedItem.value = baustein;
  }

  // Drop in "Nicht ausgewählte Bausteine"
  function dropToAvailable() {
    if (selectedDraggedItem.value) {
      selectedTextbausteine.value = selectedTextbausteine.value.filter(
        (b: VorlageTextbaustein) => b.textbausteinid !== selectedDraggedItem.value!.textbausteinid
      );

      reorderSelected();
    }

    notSelectedDraggedItem.value = null;
    selectedDraggedItem.value = null;
    dropTargetId.value = null;
  }

  const selectedDraggedItem = ref<VorlageTextbaustein | null>(null);
  function startDrag(baustein: VorlageTextbaustein) {
    selectedDraggedItem.value = baustein;
  }

  // Drop in "Ausgewählte Bausteine"
  function dropToSelected() {
    if (notSelectedDraggedItem.value != undefined && !selectedTextbausteine.value.map((t) => t.textbausteinid).includes(notSelectedDraggedItem.value.id)) {
      selectedTextbausteine.value.push(new VorlageTextbaustein(editVorlage.value.id, notSelectedDraggedItem.value, selectedTextbausteine.value.length + 1));
    } else if (selectedDraggedItem.value != undefined) {
      selectedDraggedItem.value.position = selectedTextbausteine.value.length;

      const selectedIndex = selectedTextbausteine.value.findIndex((b) => b.textbausteinid == selectedDraggedItem.value?.textbausteinid);
      if (selectedIndex != -1) {
        selectedTextbausteine.value.splice(selectedIndex, 1);
      }

      selectedTextbausteine.value.push(selectedDraggedItem.value);
      reorderSelected();
      // selectedTextbausteine.value = selectedTextbausteine.value.filter((b) => b.textbausteinid !== selectedDraggedItem.value!.textbausteinid);
    }

    notSelectedDraggedItem.value = null;
    selectedDraggedItem.value = null;
    dropTargetId.value = null;
  }

  // Drag & Drop für Sortierung innerhalb der "ausgewählten Bausteine"
  const handleDragOver = (event: DragEvent) => {
    event.preventDefault();
  };

  const dropTargetId = ref<number | null>(null); // Speichert das Ziel-Element für die visuelle Markierung

  // Markiert das Ziel, über das gerade gezogen wird
  function handleDragEnter(targetBaustein: VorlageTextbaustein) {
    dropTargetId.value = targetBaustein.textbausteinid;
  }

  // Löscht die Markierung, wenn das Element das Ziel verlässt
  const handleDragLeave = (event: DragEvent, _targetBaustein: VorlageTextbaustein) => {
    if (!event.relatedTarget || !(event.relatedTarget as HTMLElement).closest('.selectable-textbaustein')) {
      dropTargetId.value = null;
    }
  };

  const handleDrop = (event: DragEvent, targetBaustein: VorlageTextbaustein) => {
    event.preventDefault();

    let item: VorlageTextbaustein | null = null;
    if (notSelectedDraggedItem.value) {
      item = new VorlageTextbaustein(editVorlage.value.id, notSelectedDraggedItem.value, selectedTextbausteine.value.length + 1);
    } else if (selectedDraggedItem.value) {
      item = selectedDraggedItem.value;
    }

    if (!item || item.textbausteinid === targetBaustein.textbausteinid) return;

    const items = selectedTextbausteine.value;
    const draggedIndex = items.findIndex((b) => b.textbausteinid === item.textbausteinid);
    const targetIndex = items.findIndex((b) => b.textbausteinid === targetBaustein.textbausteinid);

    // Element aus der alten Position entfernen
    if (draggedIndex > -1) {
      items.splice(draggedIndex, 1);
    }

    // Element an neuer Position einfügen
    if (draggedIndex == -1) {
      items.splice(targetIndex, 0, item);
    } else if (draggedIndex < targetIndex) {
      items.splice(targetIndex - 1, 0, item);
    } else if (draggedIndex > targetIndex) {
      items.splice(targetIndex, 0, item);
    }

    // Positionen neu setzen
    items.forEach((b, index) => {
      b.position = index + 1;
    });

    selectedTextbausteine.value = items;
    notSelectedDraggedItem.value = null;
    selectedDraggedItem.value = null;
    dropTargetId.value = null;
  };
  //#endregion

  //#region Load, Edit & Save
  const getTextbausteineLoading = computed(() => store.getters.status.getTextbausteineLoading);
  // const textbausteinErrorMsg = computed(() => store.getters.status.textbausteinErrorMsg);

  const textbausteine = computed(() => store.getters.textbausteine);

  const vorlage = computed(() => store.getters.vorlagen.find((v: Vorlage) => v.id == Number.parseInt(props.vorlageid)));
  const tmpVorlage = ref<Vorlage | null>(vorlage.value != null ? (JSON.parse(JSON.stringify(vorlage.value)) as Vorlage) : null);

  const editVorlage = ref<Vorlage>(tmpVorlage.value != null ? tmpVorlage.value : new Vorlage());
  // Damit die AbschnitteRegeln in den Textbausteinen initialisiert werden, falls noch nicht vorhanden
  addAbschnittRegelnToTextbausteine();
  // Initialisiere die ausgewählten Textbausteine
  selectedTextbausteine.value = editVorlage.value.vorlageTextbausteine;
  if (selectedTextbausteine.value.length > 0 && selectedTextbausteine.value.map((t) => t.position).includes(0)) {
    reorderSelected();
  }

  const loading = computed(
    () => store.getters.status.createVorlageLoading || store.getters.status.updateVorlageLoading || store.getters.status.deleteVorlageLoading
  );

  const errorMsg = computed(() => store.getters.status.vorlageErrorMsg);
  const ownErrorMsg = ref('');

  function addAbschnittRegelnToTextbausteine() {
    for (let vorlageTextbaustein of editVorlage.value.vorlageTextbausteine) {
      if (vorlageTextbaustein.abschnittRegeln == undefined) {
        vorlageTextbaustein.abschnittRegeln = new Array();
      }

      // Wenn noch keine Regeln für die Abschnitte vorhanden sind, erstelle Standard-Regeln (alle Abschnitte optional)
      if (vorlageTextbaustein.abschnittRegeln.some((r) => r.textbausteinId == vorlageTextbaustein.textbausteinid) == false) {
        vorlageTextbaustein.abschnittRegeln.push(
          new VorlageAbschnittRegel(vorlageTextbaustein.id, vorlageTextbaustein.textbausteinid, vorlageTextbaustein.optional)
        );
      }

      // Regeln für Abschnitte erstellen, die noch keine Regel haben
      for (let abschnitt of vorlageTextbaustein.textbaustein.abschnitte) {
        if (vorlageTextbaustein.abschnittRegeln.some((r) => r.textbausteinId == abschnitt.id) == false) {
          vorlageTextbaustein.abschnittRegeln.push(new VorlageAbschnittRegel(vorlageTextbaustein.id, abschnitt.id, true));
        }
      }
    }
  }

  function nameAlreadyUsedValidation(name: string): boolean {
    return store.getters.vorlagen.some((vorlage: Vorlage) => vorlage.name.trim() === name.trim() && vorlage.id != Number.parseInt(props.vorlageid));
  }

  async function saveVorlage() {
    ownErrorMsg.value = '';

    if (editVorlage.value.name.trim() == '') {
      ownErrorMsg.value += '- <strong>Vorlage Bezeichnung</strong> darf nicht leer sein.';
    }
    if (editVorlage.value.titel.trim() == '') {
      if (ownErrorMsg.value != '') {
        ownErrorMsg.value += '<br>';
      }
      ownErrorMsg.value += '- <strong>Vertrag Titel</strong> darf nicht leer sein.';
    }
    if (editVorlage.value.name.trim() != '' && nameAlreadyUsedValidation(editVorlage.value.name)) {
      if (ownErrorMsg.value != '') {
        ownErrorMsg.value += '<br>';
      }
      ownErrorMsg.value += '- Der Name des Textbausteins ist bereits vergeben.';
    }
    if (ownErrorMsg.value != '') {
      return;
    }

    editVorlage.value.vorlageTextbausteine = selectedTextbausteine.value;

    if (vorlage.value != null) {
      await store.dispatch(VorlageActionTypes.UpdateVorlage, editVorlage.value);
    } else {
      await store.dispatch(VorlageActionTypes.CreateVorlage, editVorlage.value);
    }

    if (errorMsg.value == '') {
      cancel();
    }
  }

  async function loadTextbausteine() {
    await store.dispatch(VorlageActionTypes.GetTextbausteine, undefined);
  }

  function cancel() {
    router.back();
  }
  //#endregion

  //#region DELETE
  const confirmationAlertRef = ref();

  function deleteVorlageRequest() {
    confirmationAlertRef.value?.showAlert(
      'Vertragsvorlage löschen',
      'Möchten Sie die Vertragsvorlage unwiderruflich lösche?',
      'danger',
      '',
      'danger',
      'text-white'
    );
  }

  function deleteVorlage() {
    store.dispatch(VorlageActionTypes.DeleteVorlage, vorlage.value.id).then(() => {
      if (errorMsg.value == '') {
        router.push({ name: 'Vorlagen' });
      }
    });
  }
  //#endregion

  onMounted(async () => {
    if (props.vorlageid != '' && props.vorlageid != '0' && vorlage.value == undefined) {
      await store.dispatch(VorlageActionTypes.GetVorlageById, parseInt(props.vorlageid));
    }

    if (textbausteine.value.length == 0) {
      await loadTextbausteine();
    }

    if (store.getters.variablen.length == 0) {
      await store.dispatch(VariablenActionTypes.GetVariablen, undefined);
    }
  });
</script>

<style scoped>
  .save-bar {
    z-index: 1;
  }

  #edit-vorlage-view {
    margin-bottom: 70px;
  }

  .dropzone {
    min-height: 200px;
    border: 2px dashed #bbb;
    padding: 10px;
    background: #f8f9fa;
  }

  .selectable-textbaustein:hover {
    cursor: grab;
    background: #fff4af !important;
    color: #000000;
  }

  /* Markiert das Ziel-Element */
  .drop-target {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 5px solid #f1a82c;
  }

  #edit-vorlage-form-main {
    margin-right: 455px; /* Platz für die Sidebar lassen */
  }

  .sidebar-fixed {
    position: fixed;
    top: 0; /* falls du eine fixed Navbar hast, z.B. top: 56px; */
    right: 0;
    bottom: 65px;
    overflow-y: auto; /* eigene Scrollbar */
    /* padding: 1rem; */
  }

  .bg-sidebar {
    background-color: #f8f8f8;
  }

  #edit-vorlage-sidebar-navbar-platzhalter {
    height: 61px;
    margin-bottom: 4px;
  }

  .edit-vorlage-sidebar {
    width: 450px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
</style>
